import BackHandOutlinedIcon from '@mui/icons-material/BackHandOutlined';

/**
 * Formato de unhas: desenho da ponta da unha, em dez formatos. Não há escala
 * clínica: a referência é a nomenclatura usual de manicure e nail design.
 * Textos nossos.
 *
 * Os valores precisam ser os mesmos de public/api/scales/catalog/nail_shape.php.
 */
const imageFor = (position) => `formato-unha-${position}.png`;

const nailShape = {
  key: 'nail_shape',
  name: 'Formato de unhas',
  description: 'Desenho da ponta da unha',
  details: 'Registra o formato da unha em dez desenhos usuais de manicure e nail design, da quadrada ao pé de pato. Ajuda a lembrar a preferência da cliente, planejar alongamento ou esmaltação e manter o mesmo formato de uma sessão para outra. Um clique marca o formato do atendimento, o card mostra o da última consulta e a aba Saúde guarda a evolução.',
  kind: 'single',
  icon: BackHandOutlinedIcon,
  accent: 'pink',
  options: [
    { value: 'square', label: 'Quadrada', caption: 'Ponta reta', image: imageFor(1), help: 'Laterais paralelas e ponta reta, com cantos vivos.' },
    { value: 'squoval', label: 'Quadrada arredondada', caption: 'Cantos suaves', image: imageFor(2), help: 'Ponta reta com os cantos levemente arredondados. Resiste bem a quebras.' },
    { value: 'round', label: 'Redonda', caption: 'Ponta curva', image: imageFor(3), help: 'Ponta em curva que acompanha o formato do dedo. Prática para unhas curtas.' },
    { value: 'oval', label: 'Oval', caption: 'Curva alongada', image: imageFor(4), help: 'Laterais levemente afinadas e ponta em curva alongada.' },
    { value: 'almond', label: 'Amendoada', caption: 'Ponta afinada', image: imageFor(5), help: 'Laterais que afinam até uma ponta arredondada, como uma amêndoa.' },
    { value: 'stiletto', label: 'Stiletto', caption: 'Ponta fina', image: imageFor(6), help: 'Laterais que afinam até uma ponta fina e marcada. Pede unha longa.' },
    { value: 'ballerina', label: 'Bailarina', caption: 'Coffin', image: imageFor(7), help: 'Laterais afinadas e ponta reta, como uma sapatilha de balé.' },
    { value: 'lipstick', label: 'Lipstick', caption: 'Ponta diagonal', image: imageFor(8), help: 'Ponta cortada em diagonal, como a de um batom novo.' },
    { value: 'edge', label: 'Pico de montanha', caption: 'Edge', image: imageFor(9), help: 'Ponta afinada com uma aresta central, formando um pico.' },
    { value: 'flare', label: 'Pé de pato', caption: 'Flare', image: imageFor(10), help: 'Ponta que se abre para os lados, mais larga que a base.' },
  ],
};

export default nailShape;
